module.exports = __webpack_public_path__ + "static/media/docks.22008748.glb";